import { UsersTable, UsersHeader } from 'components';
import { getUsers } from 'services/users';
import { ListProvider } from 'contexts';

export const Users = () => {
	return (
		<ListProvider
			lastPageName='lastPageUsers'
			fetch={getUsers}
		>
			<UsersHeader />
			<UsersTable />
		</ListProvider>
	);
};
